module.exports = __webpack_public_path__ + "./fonts/KaushanScript-Regular.ttf";